import styled from 'styled-components';

export const Symbol = styled.img`
  display: inline-block;
  width: ${props => props.$size || '1.15em'};
  height: ${props => props.$size || '1.15em'};
  vertical-align: -0.2em;
  border-radius: 50%;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, .35);
`;

export const Cost = styled.span`
  display: inline-flex;
  gap: 2px;
  vertical-align: middle;

  img {
    vertical-align: 0;
  }
`;
